import { render, staticRenderFns } from "./register-new.vue?vue&type=template&id=72df86d9&scoped=true"
import script from "./register-new.vue?vue&type=script&lang=js"
export * from "./register-new.vue?vue&type=script&lang=js"
import style0 from "./register-new.vue?vue&type=style&index=0&id=72df86d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df86d9",
  null
  
)

export default component.exports